import type { StateCreator } from 'zustand';

import { OnboardingStatus } from '@cobliteam/common-types';

import type { Step } from '@cobliteam/api-lib';

import type { StepStatus } from '../../utils';

interface OnboardingStep {
  stepName: Step;
  startedAt: number | undefined;
  endedAt: number | undefined;
  skippedAt: number | undefined;
  stepStatus: StepStatus;
  dependsOn: Step | undefined;
  dependentStepStartedAt: number | undefined;
  dependentStepEndedAt: number | undefined;
}

interface OnboardingStepsSliceState {
  tourStepsIndex: number;
  tourStepsTotal: number;
  progressBar: boolean;
  welcomeModal: boolean;
  onboardingStepsIndex: number;
  onboardingStepsTotal: number;
  onboardingShowSidebar: boolean;
  hideDeviceTrackBlock: boolean;
  hasOnboarding: boolean;
  onboardingSteps: (OnboardingStep | undefined)[];
  onboardingStatus: OnboardingStatus;
  setHasOnboarding: (value: boolean) => void;
  setOnboardingSteps: (value: (OnboardingStep | undefined)[]) => void;
  setWelcomeModal: (value: boolean) => void;
  setTourStepsIndex: (value: number) => void;
  setTourStepsTotal: (value: number) => void;
  setOnboardingStepsIndex: (value: number) => void;
  setOnboardingStepsTotal: (value: number) => void;
  setOnboardingShowSidebar: (value: boolean) => void;
  setHideDeviceTrackBlock: (value: boolean) => void;
  setOnboardingStatus: (value: OnboardingStatus) => void;
  setTourReset: () => void;
}

type StateCreatorOnboardingSteps = StateCreator<OnboardingStepsSliceState>;

const initialStates = {
  tourStepsIndex: 0,
  tourStepsTotal: 0,
  progressBar: false,
  welcomeModal: true,
  hasOnboarding: false,
  onboardingSteps: [],
  onboardingStepsIndex: 0,
  onboardingStepsTotal: 7,
  onboardingShowSidebar: true,
  hideDeviceTrackBlock: false,
  toursCompleted: undefined,
  onboardingStatus: OnboardingStatus.IN_PROGRESS,
};

const createOnboardingStepsSlice: StateCreatorOnboardingSteps = (set) => ({
  ...initialStates,
  setOnboardingSteps: (onboardingSteps: (OnboardingStep | undefined)[]) =>
    set({ onboardingSteps }),
  setWelcomeModal: (welcomeModal: boolean) => set({ welcomeModal }),
  setHasOnboarding: (hasOnboarding: boolean) => set({ hasOnboarding }),
  setTourStepsIndex: (tourStepsIndex: number) => set({ tourStepsIndex }),
  setTourStepsTotal: (tourStepsTotal: number) => set({ tourStepsTotal }),
  setOnboardingStepsIndex: (onboardingStepsIndex: number) =>
    set({ onboardingStepsIndex }),
  setOnboardingStepsTotal: (onboardingStepsTotal: number) =>
    set({ onboardingStepsTotal }),
  setOnboardingShowSidebar: (onboardingShowSidebar: boolean) =>
    set({ onboardingShowSidebar }),
  setHideDeviceTrackBlock: (hideDeviceTrackBlock: boolean) =>
    set({ hideDeviceTrackBlock }),
  setOnboardingStatus: (onboardingStatus: OnboardingStatus) =>
    set({ onboardingStatus }),
  setTourReset: () =>
    set({
      tourStepsIndex: 0,
      tourStepsTotal: 0,
      progressBar: false,
    }),
});

export default createOnboardingStepsSlice;
export type { OnboardingStep, OnboardingStepsSliceState };
